export enum ContentScriptAction {
  ExtensionAuthStatusChanged = '[ContentScript] ExtensionAuthStatusChanged',
  GetLocalStorage = '[ContentScript] GetLocalStorage',
  GetProfileEmail = '[ContentScript] GetProfileEmail',
  GetUserDetails = '[ContentScript] GetUserDetails',
  InitiateThirdPartyAppLogin = '[ContentScript] InitiateThirdPartyAppLogin',
  LocalStorageChanged = '[ContentScript] LocalStorageChanged',
  OpenThirdPartyAppCredentialsPopup = '[ContentScript] OpenThirdPartyAppCredentialsPopup',
  SetLocalStorage = '[ContentScript] SetLocalStorage',
  SendDashboardMessage = '[ContentScript] SendDashboardMessage',
  ViewChanged = '[ContentScript] ViewChanged',
}
